
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import ViewProfile from '../../components/ViewProfile';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';

// GraphQL
import ProfileQuery from './Profile.graphql';
import UserReviewsQuery from './UserReviews.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './Profile.css';

const Profile = (props) => {

  const { title, profileId, isUser, profileData: { loading, showUserProfile }, userReviewsData: { loading: reviewsLoading, fetchMore: reviewsFetchMore, userReviews } } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    if (userReviews?.results != null && reviews === null) {
      setReviews(userReviews.results);
    }
  }, [userReviews?.results]);

  const loadMore = () => {
    setIsLoading(true)
    reviewsFetchMore({
      variables: {
        ownerType: 'others',
        offset: reviews?.length || 0,
        profileId,
        loadCount: 3,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) { return previousResult; }
        return {
          userReviews: {
            ...previousResult.userReviews,
            results: fetchMoreResult.userReviews.results,
          },
        };
      },
    }).then((result) => {
      const newResults = result?.data?.userReviews?.results || [];
      setReviews(prev => [...(prev || []), ...newResults]);
      setIsLoading(false);
    })
  }

  let userBanStatusValue;
  if (showUserProfile) {
    userBanStatusValue = showUserProfile.profileBanStatus.userBanStatus;
  }
  if (!loading && !showUserProfile || userBanStatusValue) {
    return <NotFound />
  }

  const isDataLoading = loading || reviewsLoading || reviews === null;
  const profileDataWithReviews = showUserProfile ? {
    ...showUserProfile,
    reviews: reviews || [],
  } : null;

  return (
    <div className={s.root}>
      {
        isDataLoading && <Loader type={"text"} />
      }
      {
        !isDataLoading && <div>
          <ViewProfile
            loading={isLoading}
            data={profileDataWithReviews}
            isUser={isUser}
            loadMore={loadMore}
            profileId={profileId}
          />
        </div>
      }
    </div>
  );
}

Profile.propTypes = {
  title: PropTypes.string.isRequired,
  profileId: PropTypes.number,
  isUser: PropTypes.bool,
  userBanStatusValue: PropTypes.number,
};
Profile.defaultProps = {
  isUser: false,
  userBanStatusValue: 0,
};

export default compose(
  withStyles(s),
  withQuery(ProfileQuery,
    {
      name: 'profileData',
      options: (props) => ({
        variables: {
          profileId: props.profileId,
          isUser: props.isUser,
        },
        ssr: false,
        fetchPolicy: 'network-only',
      })
    }
  ),
  withQuery(UserReviewsQuery,
    {
      name: 'userReviewsData',
      options: (props) => ({
        variables: {
          ownerType: 'others',
          offset: 0,
          profileId: props.profileId,
          loadCount: 3,
        },
        ssr: false,
        fetchPolicy: 'network-only',
      })
    }
  ),
)(Profile);
